import React from 'react';
export function Footer() {
  return <footer className="py-12 px-4 border-t border-white/10 bg-black text-center text-gray-500 text-sm font-medium" data-id="element-104">
      <div className="max-w-xl mx-auto space-y-3" data-id="element-105">
        <p className="text-brand-cream font-black uppercase tracking-wider flex items-center justify-center gap-2" data-id="element-106">
          🏔️ Swiss Peak System™
        </p>
        <p className="text-gray-400 font-medium text-sm leading-relaxed" data-id="element-107">
          Schweizer Präzision für Ihr alpines Leben. Weil Skifahren in der
          Schweiz nicht Ihr gesamtes Budget fressen sollte.
        </p>
        <p className="text-xs text-gray-600 mt-4" data-id="element-108">
          © Swiss Peak System™ 2026 — Alle Rechte vorbehalten.
        </p>
      </div>
    </footer>;
}